// Official Payple codes: https://developer.payple.kr/response-code
// SPCD1001 covers several issuer rejections, so it must not imply insufficient funds on its own.
const codeMessages: Record<string, string> = {
  SPCD0001: "등록된 카드 정보를 확인할 수 없습니다. 카드를 다시 등록해주세요.",
  SPCD0002: "결제 금액은 최소 100원 이상이어야 합니다.",
  SPCD0003: "결제 상품 정보가 누락되었습니다. 관리자에게 문의해주세요.",
  SPCD0004: "결제 인증이 만료되었습니다. 다시 시도해주세요.",
  SPCD0007: "현재 상점에서 카드 결제를 사용할 수 없습니다. 관리자에게 문의해주세요.",
  SPCD0009: "상점의 건당 결제 한도를 초과했습니다. 관리자에게 문의해주세요.",
  SPCD0010: "상점의 월 결제 한도를 초과했습니다. 관리자에게 문의해주세요.",
  SPCD0011: "등록된 카드 정보를 확인할 수 없습니다. 카드를 다시 등록해주세요.",
  SPCD0012: "카드 정보가 없거나 등록이 해지되었습니다. 카드를 다시 등록해주세요.",
  SPCD0013: "카드 결제 동의가 완료되지 않았습니다. 카드를 다시 등록해주세요.",
  SPCD0014: "이미 처리된 결제입니다. 결제 내역을 확인해주세요.",
  SPCD0027: "상점의 건당 결제 한도를 초과했습니다. 관리자에게 문의해주세요.",
  SPCD1000: "같은 결제가 처리 중이거나 이미 완료되었습니다. 결제 내역을 확인해주세요.",
  SPCD1001: "카드사에서 결제를 거절했습니다. 잔액, 이용 한도 및 카드 상태를 확인하거나 다른 카드로 시도해주세요.",
  SPCD1004: "카드사에서 카드 등록을 거절했습니다. 카드 상태를 확인하거나 다른 카드를 등록해주세요.",
  SPCD9991: "결제 인증 설정에 문제가 있습니다. 관리자에게 문의해주세요.",
  SPCDF001: "카드사의 이상 거래 감지로 결제가 제한되었습니다. 카드사에 문의해주세요.",
};

export function formatPaymentFailure(reason?: string | null): string {
  if (!reason?.trim()) return "이 결제에는 저장된 실패 사유가 없습니다.";
  const text = reason.trim();
  const code = text.toUpperCase().match(/\b(?:SPCD|PCOF|PCCF|CPAY|PAYM|AUTH|SPAY)[A-Z0-9]{4}\b/)?.[0];
  const issuerRejection = !code || code === "SPCD1001" || code === "SPCD1004";
  if (issuerRejection && !text.includes("\uFFFD")) {
    const message = text.replace(/\s/g, "");
    if (/잔액부족|잔액이부족|insufficient.*(?:fund|balance)/i.test(message))
      return "잔액이 부족하여 결제하지 못했습니다. 잔액을 충전하거나 다른 카드로 시도해주세요.";
    if (/한도초과|한도를초과|한도부족/.test(message))
      return "카드 이용 한도를 초과했습니다. 카드 한도를 확인하거나 다른 카드로 시도해주세요.";
    if (/분실|도난/.test(message))
      return "분실 또는 도난 신고된 카드로 결제할 수 없습니다. 다른 카드로 시도해주세요.";
    if (/유효기간.*만료|기간만료/.test(message))
      return "카드 유효기간이 만료되었습니다. 다른 카드를 등록해주세요.";
    if (/거래정지|거래제한|사용정지/.test(message))
      return "사용이 정지되거나 거래가 제한된 카드입니다. 카드사에 확인하거나 다른 카드로 시도해주세요.";
  }
  if (code && codeMessages[code]) return codeMessages[code];
  if (/AUTH_ERROR|페이플 인증 실패/.test(text))
    return "결제 인증에 실패했습니다. 결제 환경과 인증 설정을 확인해주세요.";
  if (/PAY_REQUEST_ERROR/.test(text))
    return "결제 서버에 요청하지 못했습니다. 잠시 후 다시 시도해주세요.";
  if (/주문번호.*일치|결제금액.*일치/.test(text))
    return "결제 승인 정보가 주문 정보와 일치하지 않습니다. 결제 내역을 확인하고 관리자에게 문의해주세요.";
  if (code || /Payple|result=|code=|msg=|\uFFFD/i.test(text))
    return "결제 처리에 실패했습니다. 카드 상태를 확인하고, 문제가 계속되면 관리자에게 문의해주세요.";
  return text;
}
